import { render, staticRenderFns } from "./mideCard.vue?vue&type=template&id=bc809900&scoped=true&"
import script from "./mideCard.vue?vue&type=script&lang=js&"
export * from "./mideCard.vue?vue&type=script&lang=js&"
import style0 from "./mideCard.vue?vue&type=style&index=0&id=bc809900&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc809900",
  null
  
)

export default component.exports